module.exports = __webpack_public_path__ + "static/media/over1200.fa60d0fa.jpg";